import React, { useContext, useState } from 'react'
import CashZoneButton from '../CashZoneButton'
import LoginContext from '../../context'
import { useNavigate } from 'react-router-dom'

const WriteCustomerCenterSection = () => {
    const { token } = useContext(LoginContext)
    const [title, setTitle] = useState('')
    const [content, setContent] = useState('')
    const navigate = useNavigate();

    const handleSubmit = async () => {
        try {
            console.log("lalalala", token)
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/inquiries/inquiries`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    // 'X-CSRFTOKEN': csrfToken, // ensure this is correct
                    'Authorization': `Bearer ${token.token}`,
                },
                body: JSON.stringify({
                    title,
                    content
                })
            });

            if (!response.ok) {
                const err = await response.text();
                console.error('Submission failed: ' + err);
                return;
            }

            const data = await response.json();
            console.log('Inquiry submitted successfully!');
            console.log(data);

            navigate('/customer');
        } catch (error) {
            alert('Error submitting inquiry: ' + error.message);
        }
    };
    return (
        <>
            <table cellpadding="3" cellspacing="1" width="100%" className="text-xs text-white lg:border-t border-t-slate font-Time bg-charcoal lg:bg-transparent border lg:border-0 border-slate">
                <tbody>
                    <tr>
                        <td align="left" class="hidden lg:table-cell font-bold text-white bg-charcoal pl-2.5 p-[5px] border-b border-b-slate" width="115" height="30" >제 목</td>
                        <td align="left" className='p-[5px] border-b border-b-slate'>
                            <input type="text" name="title" id="title" value={title} onChange={(e) => setTitle(e.target.value)} size="100" class="hidden lg:inline-block w-[99%] bg-obsidian text-white text-xs leading-[39px] h-[39px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none" />
                            <input type="text" id="userid" className='lg:hidden w-[95%] bg-obsidian text-white text-xs leading-9 h-9 transition-[0.2s] align-middle px-[5px] py-0.5 border border-slate outline-none placeholder:text-[#fff4cf] focus:border-[#ffcc00]' size="100" placeholder="제목을 입력해 주세요" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </td>
                    </tr>
                    <tr>
                        <td align="left" class="hidden lg:table-cell font-bold text-white bg-charcoal pl-2.5 p-[5px] border-b border-b-slate h-[30px] leading-[30px]" width="115" height="30"  >옵 션</td>
                        <td align="left" className='p-[5px] border-b border-b-slate'>
                            <div className="inline-block align-middle lg:hidden me-1">
                                <input id="option1" type="radio" name="point_type" value="M" checked="true" disabled="true" className="peer hidden" />
                                <label htmlFor="option1" className="relative block w-5 h-5 cursor-pointer rounded-md mobile-radio-bg bg-[length:200px_200px] bg-[176px_22px] peer-checked:bg-[-22px_0] peer-disabled:bg-[-66px_0]" />
                            </div>
                            <input type="checkbox" id="secret_chk" checked="true" disabled="true" className='align-middle hidden lg:inline-block mr-1' />
                            <label for="secret_chk">비밀글</label>
                            <div className="inline-flex lg:hidden items-center gap-2 ml-2.5">
                                <CashZoneButton label="배팅내역첨부" link_src="#" active_color="bg-[#cc001b]" active={true} type="link" />
                                <CashZoneButton label="당첨내역첨부" link_src="#" active_color="bg-[#14b320]" active={true} type="link" />
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td align="left" colSpan="2" className='p-[5px] border-b border-b-slate'>
                            <div className="lg:mb-2 5"></div>
                        </td>
                    </tr>
                    <tr>
                        <td align="left" colSpan="2" className='p-[5px] border-b border-b-slate'>
                        </td>
                    </tr>
                    <tr>
                        <td height="100" colspan="2" align="left" class="text-white lg:pl-2.5 p-[5px] border-b border-b-slate" >
                            <textarea value={content} onChange={(e) => setContent(e.target.value)} name="content" id="content" cols="100" rows="17" className='w-[95%] lg:w-[99%] bg-obsidian text-white text-xs transition-[0.2s] px-[5px] py-0.5 lg:rounded-[5px] border border-slate focus:border-[#ffcc00] lg:focus:border-indigoBlue outline-none'></textarea>
                        </td>
                    </tr>
                </tbody>


            </table>
            <div className="pt-2.5 lg:pt-5 pb-7 lg:pb-10 font-Time flex justify-center items-center gap-2">
                <CashZoneButton label="저장" link_src="#" active_color="bg-[#cc001b]" active={true} type="button" onClick={handleSubmit} />
                <CashZoneButton label="목록" link_src="/customer" active_color="bg-amberGold" active={false} type="link" />
            </div>
        </>
    )
}

export default WriteCustomerCenterSection